module.exports = __webpack_public_path__ + "img/ubuntu18.8bfb585.svg";